import { jsx as _jsx } from "react/jsx-runtime";
import { Image } from '@coolblue-development/next-image/client';
export const FallbackAdSlot = ({ imageId, imageDimensions: { width, height }, altText = 'Fallback ad image', imageSizes, }) => {
    return (_jsx(Image, { fullWidth: true, fullHeight: true, loading: "eager", objectFit: "cover", fileCollection: "content", sizes: imageSizes, alt: altText, imageId: imageId, width: width, height: height }));
};
//# sourceMappingURL=FallbackAdSlot.js.map